import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=8bc09054&scoped=true"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=8bc09054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc09054",
  null
  
)

export default component.exports